import { useEffect, useState } from "react";

import { IInputOTPController } from "./types";

export const useInputOTPController = ({
  onChange,
  value
}: IInputOTPController) => {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleOnChangeInput = (text: string) => {
    onChange?.(text);
    setInputValue(text);
  };

  return {
    handleOnChangeInput,
    inputValue
  };
};
